import { createFileRoute } from '@tanstack/react-router';

import { getRecruitingQueryOptions } from '@/_pages/recruiting/api-service';
import Loading from '@/_pages/recruiting/profile/loading';

export const Route = createFileRoute('/_private/recruiting/$id')({
  loader: (opts) => opts.context.queryClient.ensureQueryData(getRecruitingQueryOptions(opts.params.id)),
  pendingComponent: Loading,
});
